// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetAlternatePackagingApiParameter } from "@store/Framework/Services/AlternatePackagingService";

export function getAlternatePackagingDataView(
    state: ApplicationState,
    getAlternatePackagingApiParameter: GetAlternatePackagingApiParameter,
) {
    return getDataView(state.greif.data.productAlternatePackaging, getAlternatePackagingApiParameter);
}
